import React, { useState } from "react";

import {
  add_tag,
  adminApprovalReview,
  create_blog,
} from "../../../api/services";
import toast from "react-hot-toast";
import { toggleForm, toggleRefresh } from "../../../redux/features/general";
import { useDispatch, useSelector } from "react-redux";
let status = ["rejected", "under_review", "approved"];

function ReviewStatus() {
  const dispatch = useDispatch();
  const { loading, data } = useSelector((state) => state.general);

  const [value, setValue] = useState({ ...initialState, status: data.status });

  async function handleSubmit(e) {
    try {
      e.preventDefault();
      const res = await adminApprovalReview({
        review_id: data.review_id,
        action: value.status,
      });
      if (res.status === 200) {
        toast.success("Review status updated. ");
        dispatch(toggleForm());
        dispatch(toggleRefresh());
        setValue({ ...initialState });
      }

      return 0;
    } catch (error) {
      toast.error("Error while adding the tag.");
    }
  }

  function handelSelect(e) {
    console.log(e.target.value);
    setValue((old) => ({
      ...old,
      [e.target.name]: e.target.value,
    }));
  }

  return (
    <div className="flex flex-col gap-5">
      <div className="header text-gray-600 flex flex-col gap-1">
        <span className="text-2xl">Update Review Status </span>
        <span className="text-xs">
          Preview and update the review status from here...
        </span>
      </div>
      {/* // form started */}
      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        <input disabled value={data.userName} className={inputClass}></input>
        <input disabled value={data.email} className={inputClass}></input>
        <textarea
          disabled
          value={data.comment}
          className={inputClass}
          required
          placeholder="Comment"
          name="comment"
        ></textarea>
        {/* select author */}
        <select
          onChange={handelSelect}
          value={value.status}
          className={inputClass}
          required
          placeholder="Select author...."
          name="status"
        >
          {status.map((row, index) => (
            <option value={row}>{row}</option>
          ))}
          <option selected={true} value={0}>
            {"Select the author"}
          </option>
        </select>
        {/* select author  end*/}
        <button
          disabled={loading}
          type="submit"
          className="bg-primary transition duration-300 hover:bg-white group hover:text-primary border-primary border p-2 text-white font-semibold rounded-lg flex gap-1 justify-center items-center"
        >
          {loading ? (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="animate-spin group-hover:fill-primary fill-white"
                width={30}
                height={25}
              >
                <title>loading</title>
                <path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
              </svg>
            </>
          ) : (
            <div className="flex items-center">
              <svg
                className=" group-hover:fill-primary fill-white"
                width={30}
                height={25}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <title>pencil</title>
                <path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" />
              </svg>
              Update Review Status
            </div>
          )}
        </button>
      </form>
      {/* // form end */}
    </div>
  );
}

const inputClass = "outline-primary p-3 border rounded-lg resize-none";

const initialState = {
  status: "",
};
export default ReviewStatus;
